




































import { Prop, Component, Vue} from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";

@Component({
    components: {
        BPopover,
    },
})
export default class AbcPopover extends Vue {

    @Prop({ required: true }) target!: string | null;
    @Prop({ default: null }) title!: string | null;
    @Prop({ default: null }) content!: string | null;
    @Prop({ default: "rigth" }) placement!:
        | "auto"
        | "top"
        | "bottom"
        | "left"
        | "right"
        | "topleft"
        | "topright"
        | "bottomleft"
        | "bottomright"
        | "lefttop"
        | "leftbottom"
        | "righttop"
        | "rightbottom";
    @Prop({ default: "flip" }) fallbackPlacement!:
        | "flip"
        | "clockwise"
        | "counterclockwise"
        | ("flip" | "clockwise" | "counterclockwise")[];
    @Prop({ type: Boolean }) disabled!: boolean;
    @Prop({ default: "click" }) triggers!: string;
    @Prop({ type: Boolean }) noFade!: boolean;
    @Prop({ type: Boolean }) noninteractive!: boolean;
    @Prop({ default: 50 }) delay!: number | { show: number; hide: number };
    @Prop({ default: 0 }) offset!: number;
    @Prop({ default: null }) container!: string | null;
    @Prop({ default: "scrollParent" }) boundary!: string;
    @Prop({ default: 5 }) boundaryPadding!: number;
    @Prop({ default: null }) variant!: string | null;
    @Prop({ default: null }) customClass!: string | null;
    @Prop({ default: null }) id!: string | null;
    @Prop({ default: Boolean }) show!: boolean;

    private get _show(){
        return this.show;
    }

    private set _show(val: boolean){
        this.$emit("update:show", val)
    }

    private get _disabled(){
        return this.disabled;
    }

    private set _disabled(val: boolean){
        this.$emit("update:disabled", val)
    }
}
